import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import React, { Dispatch, FC, SetStateAction, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import LocationSearch from '@features/applications/components/LocationSearch/LocationSearch';
import BusinessIcon from '@mui/icons-material/Business';

type CompaniesDropdownModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  selectedCompanyId: string | number;
  setSelectedCompanyId: Dispatch<SetStateAction<string | number>>;
  setIsCompanyPaid: Dispatch<SetStateAction<boolean>>;
  setIsBoostOpen: Dispatch<SetStateAction<boolean>>;
};

const CompaniesDropdownModal: FC<CompaniesDropdownModalProps> = ({
  handleClose,
  isOpen,
  setSelectedCompanyId,
  selectedCompanyId,
  setIsCompanyPaid,
  setIsBoostOpen,
}) => {
  const [pageNo, setPageNo] = useState(1);
  const handlePageNo = (newPageNo: number) => {
    setPageNo(newPageNo);
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <br />
        <BusinessIcon sx={{ fontSize: 60, color: 'primary', margin: 'auto' }} />
        <Typography variant="h4" sx={{ p: 3 }}>
          Select Company for Boost
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3}>
          <LocationSearch
            setSelectedCompanyId={setSelectedCompanyId}
            setIsCompanyPaid={setIsCompanyPaid}
            selectedCompanyId={selectedCompanyId}
            boost={true}
            handlePageNo={handlePageNo}
            disbaleExpiredCompanies={true}
          />
          <Button
            sx={{ marginBottom: '15px !important' }}
            onClick={() => setIsBoostOpen(true)}
            disabled={!selectedCompanyId}
            variant="contained"
            fullWidth
          >
            Next
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default CompaniesDropdownModal;
